import { render, staticRenderFns } from "./LoginOldDomainWarning.vue?vue&type=template&id=e6ac0c40&"
import script from "./LoginOldDomainWarning.vue?vue&type=script&lang=js&"
export * from "./LoginOldDomainWarning.vue?vue&type=script&lang=js&"
import style0 from "./LoginOldDomainWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports